import {useContext, useEffect} from 'react';
import {get, isNil} from 'lodash';

import {REPORT_ELIGIBLE_ACCELERATOR_BONUS} from '/enum/records.enum';
import {SORTS} from '/enum/sort.enum';

import {RecordsSortContext} from '/context/RecordsSort';

export function useRecordsSorting({recordsName, isViewTeam}: any) {
  // @ts-expect-error TS(2339): Property 'sortParams' does not exist on type 'unkn... Remove this comment to see the full error message
  const {
    sortParams,
    setInitialSortParams,
    resetSortParams,
    setSelectedSortParam,
  } = useContext(RecordsSortContext);

  const sortParam = get(sortParams, recordsName);

  useEffect(() => {
    if (isNil(sortParam)) {
      if (isViewTeam && recordsName === REPORT_ELIGIBLE_ACCELERATOR_BONUS) {
        setSelectedSortParam({
          recordsName,
          sortParam: SORTS.generationDesc,
        });
      } else {
        setInitialSortParams({recordsName});
      }
    }
  }, [sortParam, isViewTeam, recordsName]);

  return {
    isReadyToLoad: !isNil(sortParam),
    sortParam,
    isViewTeamsSortParams: isViewTeam,
    resetSortParams: () => resetSortParams({recordsName}),
  };
}
